/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateArticle = /* GraphQL */ `
  subscription OnCreateArticle($owner: String!) {
    onCreateArticle(owner: $owner) {
      id
      name
      description
      owner
      postedDate
      attachments {
        items {
          id
          contentType
          path
          owner
          articleId
          postedDate
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      labels {
        items {
          id
          articleId
          labelId
          owner
          postedDate
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      positionName
      latitude
      longitude
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateArticle = /* GraphQL */ `
  subscription OnUpdateArticle($owner: String!) {
    onUpdateArticle(owner: $owner) {
      id
      name
      description
      owner
      postedDate
      attachments {
        items {
          id
          contentType
          path
          owner
          articleId
          postedDate
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      labels {
        items {
          id
          articleId
          labelId
          owner
          postedDate
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      positionName
      latitude
      longitude
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteArticle = /* GraphQL */ `
  subscription OnDeleteArticle($owner: String!) {
    onDeleteArticle(owner: $owner) {
      id
      name
      description
      owner
      postedDate
      attachments {
        items {
          id
          contentType
          path
          owner
          articleId
          postedDate
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      labels {
        items {
          id
          articleId
          labelId
          owner
          postedDate
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      positionName
      latitude
      longitude
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateAttachment = /* GraphQL */ `
  subscription OnCreateAttachment($owner: String!) {
    onCreateAttachment(owner: $owner) {
      id
      contentType
      path
      owner
      articleId
      postedDate
      article {
        id
        name
        description
        owner
        postedDate
        attachments {
          nextToken
          __typename
        }
        labels {
          nextToken
          __typename
        }
        positionName
        latitude
        longitude
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateAttachment = /* GraphQL */ `
  subscription OnUpdateAttachment($owner: String!) {
    onUpdateAttachment(owner: $owner) {
      id
      contentType
      path
      owner
      articleId
      postedDate
      article {
        id
        name
        description
        owner
        postedDate
        attachments {
          nextToken
          __typename
        }
        labels {
          nextToken
          __typename
        }
        positionName
        latitude
        longitude
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteAttachment = /* GraphQL */ `
  subscription OnDeleteAttachment($owner: String!) {
    onDeleteAttachment(owner: $owner) {
      id
      contentType
      path
      owner
      articleId
      postedDate
      article {
        id
        name
        description
        owner
        postedDate
        attachments {
          nextToken
          __typename
        }
        labels {
          nextToken
          __typename
        }
        positionName
        latitude
        longitude
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateLabel = /* GraphQL */ `
  subscription OnCreateLabel($owner: String!) {
    onCreateLabel(owner: $owner) {
      id
      name
      color
      owner
      postedDate
      articles {
        items {
          id
          articleId
          labelId
          owner
          postedDate
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateLabel = /* GraphQL */ `
  subscription OnUpdateLabel($owner: String!) {
    onUpdateLabel(owner: $owner) {
      id
      name
      color
      owner
      postedDate
      articles {
        items {
          id
          articleId
          labelId
          owner
          postedDate
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteLabel = /* GraphQL */ `
  subscription OnDeleteLabel($owner: String!) {
    onDeleteLabel(owner: $owner) {
      id
      name
      color
      owner
      postedDate
      articles {
        items {
          id
          articleId
          labelId
          owner
          postedDate
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateArticleLabelJoin = /* GraphQL */ `
  subscription OnCreateArticleLabelJoin($owner: String!) {
    onCreateArticleLabelJoin(owner: $owner) {
      id
      articleId
      labelId
      owner
      postedDate
      article {
        id
        name
        description
        owner
        postedDate
        attachments {
          nextToken
          __typename
        }
        labels {
          nextToken
          __typename
        }
        positionName
        latitude
        longitude
        createdAt
        updatedAt
        __typename
      }
      label {
        id
        name
        color
        owner
        postedDate
        articles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateArticleLabelJoin = /* GraphQL */ `
  subscription OnUpdateArticleLabelJoin($owner: String!) {
    onUpdateArticleLabelJoin(owner: $owner) {
      id
      articleId
      labelId
      owner
      postedDate
      article {
        id
        name
        description
        owner
        postedDate
        attachments {
          nextToken
          __typename
        }
        labels {
          nextToken
          __typename
        }
        positionName
        latitude
        longitude
        createdAt
        updatedAt
        __typename
      }
      label {
        id
        name
        color
        owner
        postedDate
        articles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteArticleLabelJoin = /* GraphQL */ `
  subscription OnDeleteArticleLabelJoin($owner: String!) {
    onDeleteArticleLabelJoin(owner: $owner) {
      id
      articleId
      labelId
      owner
      postedDate
      article {
        id
        name
        description
        owner
        postedDate
        attachments {
          nextToken
          __typename
        }
        labels {
          nextToken
          __typename
        }
        positionName
        latitude
        longitude
        createdAt
        updatedAt
        __typename
      }
      label {
        id
        name
        color
        owner
        postedDate
        articles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
